export default __webpack_public_path__ + "static/media/logo.21981d6d.svg";